//
//
//
//
//
//
//
//
//
//
//
//
//

import FreelancersSearchItem from './FreelancersSearchItem.vue'

// noinspection JSUnusedGlobalSymbols
export default {
  name: 'FreelancersSearchList',
  components: { FreelancersSearchItem },
  props: {
    freelancers: {
      type: Array,
      default () {
        return []
      }
    }
  }
}
